import { Component, OnInit } from '@angular/core';
import { SettingsService } from './core/services/settings.service';
import { AccessService } from './core/services/access.service';
import { EfoUtilService } from './shared/services/efo-util.service';
import { EfoEgiService } from './shared/services/egi.service';
import { NavigationStart, Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  lastUrl: string;

  constructor(
    private appSettings: SettingsService,
    public accessApi: AccessService,
    private efoEgi: EfoEgiService, //Need this here!!!
    private efoUtil: EfoUtilService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.appSettings.set(this.appSettings.configSettings);
    this.efoUtil.setBrowserCSSClasses(navigator.userAgent);
    if (!$('html').hasClass('mobile')) {
      $('html').addClass('desktop');
    }
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        const fauxboxKey = _.first(e.url.match(/[a-z0-9]{32}/g));
        this.appSettings.set({ apiKey: fauxboxKey });
        this.lastUrl = e.url;
      }
    });
    this.accessApi.mee.subscribe((me) => {
      if (me.status === 0) {
        localStorage.setItem('loginUrl', this.lastUrl);
        this.router.navigate(['/authentication/sign-in']);
      }
    });
  }
}
